var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.payload.data === 'EVALUATE')?[_c('userCommentElement',{attrs:{"payload":_vm.payload,"message":_vm.message}})]:(_vm.payload.data === 'inviteGroupChat')?[_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.message.nick)+"邀请"+_vm._s(_vm.payload.extension)+"加入群聊")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }